var _debug=false;
var server_url = "https://play.grip.show";